/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/**
 * This file was auto-generated by `yarn generate-openapi-contracts`.
 * Do not make direct changes to the file.
 */

import { fetchAsJson, applyParameters } from '@modules/query/helpers'
import type { Exact } from '@modules/ts-essentials'

import type { operations, components } from './types'

// GET /api/v1/serverless/projects/elasticsearch
// ts-unused-exports:disable-next-line
export const listElasticsearchProjects = async (args?: {
  queryParameters?: operations['listElasticsearchProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProjectList']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/serverless/projects/elasticsearch
// ts-unused-exports:disable-next-line
export const createElasticsearchProject = async <
  T = operations['createElasticsearchProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createElasticsearchProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['createElasticsearchProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createElasticsearchProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProjectCreated']>(
    '/api/v1/serverless/projects/elasticsearch',
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/serverless/projects/elasticsearch/{id}
// ts-unused-exports:disable-next-line
export const getElasticsearchProject = async (args: {
  pathParameters: operations['getElasticsearchProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProject']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/serverless/projects/elasticsearch/{id}
// ts-unused-exports:disable-next-line
export const patchElasticsearchProject = async <
  T = operations['patchElasticsearchProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['patchElasticsearchProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['patchElasticsearchProject']['parameters']['path']
  body: Exact<
    T,
    operations['patchElasticsearchProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['patchElasticsearchProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ElasticsearchProject']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/serverless/projects/elasticsearch/{id}
// ts-unused-exports:disable-next-line
export const deleteElasticsearchProject = async (args: {
  pathParameters: operations['deleteElasticsearchProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/serverless/projects/elasticsearch/{id}', args), {
    method: 'DELETE',
  })

// POST /api/v1/serverless/projects/elasticsearch/{id}/_reset-credentials
// ts-unused-exports:disable-next-line
export const resetElasticsearchProjectCredentials = async (args: {
  pathParameters: operations['resetElasticsearchProjectCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}/_reset-credentials', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/elasticsearch/{id}/_reset-internal-credentials
// ts-unused-exports:disable-next-line
export const resetElasticsearchProjectInternalCredentials = async (args: {
  pathParameters: operations['resetElasticsearchProjectInternalCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters(
      '/api/v1/serverless/projects/elasticsearch/{id}/_reset-internal-credentials',
      args,
    ),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/elasticsearch/{id}/_resume
// ts-unused-exports:disable-next-line
export const resumeElasticsearchProject = async (args: {
  pathParameters: operations['resumeElasticsearchProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}/_resume', args),
    {
      method: 'POST',
    },
  )

// GET /api/v1/serverless/projects/elasticsearch/{id}/link-candidates
// ts-unused-exports:disable-next-line
export const getElasticsearchProjectLinkCandidates = async (args: {
  pathParameters: operations['getElasticsearchProjectLinkCandidates']['parameters']['path']
  queryParameters?: operations['getElasticsearchProjectLinkCandidates']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['LinkedCandidatesList']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}/link-candidates', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/elasticsearch/{id}/roles
// ts-unused-exports:disable-next-line
export const getElasticsearchProjectRoles = async (args: {
  pathParameters: operations['getElasticsearchProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/elasticsearch/{id}/status
// ts-unused-exports:disable-next-line
export const getElasticsearchProjectStatus = async (args: {
  pathParameters: operations['getElasticsearchProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/serverless/projects/elasticsearch/{id}/status', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/observability
// ts-unused-exports:disable-next-line
export const listObservabilityProjects = async (args?: {
  queryParameters?: operations['listObservabilityProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['ObservabilityProjectList']>(
    applyParameters('/api/v1/serverless/projects/observability', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/serverless/projects/observability
// ts-unused-exports:disable-next-line
export const createObservabilityProject = async <
  T = operations['createObservabilityProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createObservabilityProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['createObservabilityProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createObservabilityProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ObservabilityProjectCreated']>(
    '/api/v1/serverless/projects/observability',
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/serverless/projects/observability/{id}
// ts-unused-exports:disable-next-line
export const getObservabilityProject = async (args: {
  pathParameters: operations['getObservabilityProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ObservabilityProject']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/serverless/projects/observability/{id}
// ts-unused-exports:disable-next-line
export const patchObservabilityProject = async <
  T = operations['patchObservabilityProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['patchObservabilityProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['patchObservabilityProject']['parameters']['path']
  body: Exact<
    T,
    operations['patchObservabilityProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['patchObservabilityProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ObservabilityProject']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/serverless/projects/observability/{id}
// ts-unused-exports:disable-next-line
export const deleteObservabilityProject = async (args: {
  pathParameters: operations['deleteObservabilityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/serverless/projects/observability/{id}', args), {
    method: 'DELETE',
  })

// POST /api/v1/serverless/projects/observability/{id}/_reset-credentials
// ts-unused-exports:disable-next-line
export const resetObservabilityProjectCredentials = async (args: {
  pathParameters: operations['resetObservabilityProjectCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}/_reset-credentials', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/observability/{id}/_reset-internal-credentials
// ts-unused-exports:disable-next-line
export const resetObservabilityProjectInternalCredentials = async (args: {
  pathParameters: operations['resetObservabilityProjectInternalCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters(
      '/api/v1/serverless/projects/observability/{id}/_reset-internal-credentials',
      args,
    ),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/observability/{id}/_resume
// ts-unused-exports:disable-next-line
export const resumeObservabilityProject = async (args: {
  pathParameters: operations['resumeObservabilityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/serverless/projects/observability/{id}/_resume', args),
    {
      method: 'POST',
    },
  )

// GET /api/v1/serverless/projects/observability/{id}/link-candidates
// ts-unused-exports:disable-next-line
export const getObservabilityProjectLinkCandidates = async (args: {
  pathParameters: operations['getObservabilityProjectLinkCandidates']['parameters']['path']
  queryParameters?: operations['getObservabilityProjectLinkCandidates']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['LinkedCandidatesList']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}/link-candidates', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/observability/{id}/roles
// ts-unused-exports:disable-next-line
export const getObservabilityProjectRoles = async (args: {
  pathParameters: operations['getObservabilityProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/observability/{id}/status
// ts-unused-exports:disable-next-line
export const getObservabilityProjectStatus = async (args: {
  pathParameters: operations['getObservabilityProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/serverless/projects/observability/{id}/status', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/security
// ts-unused-exports:disable-next-line
export const listSecurityProjects = async (args?: {
  queryParameters?: operations['listSecurityProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['SecurityProjectList']>(
    applyParameters('/api/v1/serverless/projects/security', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/serverless/projects/security
// ts-unused-exports:disable-next-line
export const createSecurityProject = async <
  T = operations['createSecurityProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createSecurityProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['createSecurityProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createSecurityProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['SecurityProjectCreated']>(
    '/api/v1/serverless/projects/security',
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/serverless/projects/security/{id}
// ts-unused-exports:disable-next-line
export const getSecurityProject = async (args: {
  pathParameters: operations['getSecurityProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['SecurityProject']>(
    applyParameters('/api/v1/serverless/projects/security/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/serverless/projects/security/{id}
// ts-unused-exports:disable-next-line
export const patchSecurityProject = async <
  T = operations['patchSecurityProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['patchSecurityProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['patchSecurityProject']['parameters']['path']
  body: Exact<
    T,
    operations['patchSecurityProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['patchSecurityProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['SecurityProject']>(
    applyParameters('/api/v1/serverless/projects/security/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/serverless/projects/security/{id}
// ts-unused-exports:disable-next-line
export const deleteSecurityProject = async (args: {
  pathParameters: operations['deleteSecurityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/serverless/projects/security/{id}', args), {
    method: 'DELETE',
  })

// POST /api/v1/serverless/projects/security/{id}/_reset-credentials
// ts-unused-exports:disable-next-line
export const resetSecurityProjectCredentials = async (args: {
  pathParameters: operations['resetSecurityProjectCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters('/api/v1/serverless/projects/security/{id}/_reset-credentials', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/security/{id}/_reset-internal-credentials
// ts-unused-exports:disable-next-line
export const resetSecurityProjectInternalCredentials = async (args: {
  pathParameters: operations['resetSecurityProjectInternalCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters('/api/v1/serverless/projects/security/{id}/_reset-internal-credentials', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/security/{id}/_resume
// ts-unused-exports:disable-next-line
export const resumeSecurityProject = async (args: {
  pathParameters: operations['resumeSecurityProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/serverless/projects/security/{id}/_resume', args), {
    method: 'POST',
  })

// GET /api/v1/serverless/projects/security/{id}/link-candidates
// ts-unused-exports:disable-next-line
export const getSecurityProjectLinkCandidates = async (args: {
  pathParameters: operations['getSecurityProjectLinkCandidates']['parameters']['path']
  queryParameters?: operations['getSecurityProjectLinkCandidates']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['LinkedCandidatesList']>(
    applyParameters('/api/v1/serverless/projects/security/{id}/link-candidates', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/security/{id}/roles
// ts-unused-exports:disable-next-line
export const getSecurityProjectRoles = async (args: {
  pathParameters: operations['getSecurityProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/serverless/projects/security/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/security/{id}/status
// ts-unused-exports:disable-next-line
export const getSecurityProjectStatus = async (args: {
  pathParameters: operations['getSecurityProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/serverless/projects/security/{id}/status', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/workplaceai
// ts-unused-exports:disable-next-line
export const listWorkplaceAIProjects = async (args?: {
  queryParameters?: operations['listWorkplaceAIProjects']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['WorkplaceAIProjectList']>(
    applyParameters('/api/v1/serverless/projects/workplaceai', args),
    {
      method: 'GET',
    },
  )

// POST /api/v1/serverless/projects/workplaceai
// ts-unused-exports:disable-next-line
export const createWorkplaceAIProject = async <
  T = operations['createWorkplaceAIProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['createWorkplaceAIProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  body: Exact<
    T,
    operations['createWorkplaceAIProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createWorkplaceAIProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['WorkplaceAIProjectCreated']>(
    '/api/v1/serverless/projects/workplaceai',
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/serverless/projects/workplaceai/{id}
// ts-unused-exports:disable-next-line
export const getWorkplaceAIProject = async (args: {
  pathParameters: operations['getWorkplaceAIProject']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['WorkplaceAIProject']>(
    applyParameters('/api/v1/serverless/projects/workplaceai/{id}', args),
    {
      method: 'GET',
    },
  )

// PATCH /api/v1/serverless/projects/workplaceai/{id}
// ts-unused-exports:disable-next-line
export const patchWorkplaceAIProject = async <
  T = operations['patchWorkplaceAIProject']['requestBody'] extends undefined
    ? undefined
    : Exclude<
        operations['patchWorkplaceAIProject']['requestBody'],
        undefined
      >['content']['application/json'],
>(args: {
  pathParameters: operations['patchWorkplaceAIProject']['parameters']['path']
  body: Exact<
    T,
    operations['patchWorkplaceAIProject']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['patchWorkplaceAIProject']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['WorkplaceAIProject']>(
    applyParameters('/api/v1/serverless/projects/workplaceai/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// DELETE /api/v1/serverless/projects/workplaceai/{id}
// ts-unused-exports:disable-next-line
export const deleteWorkplaceAIProject = async (args: {
  pathParameters: operations['deleteWorkplaceAIProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/serverless/projects/workplaceai/{id}', args), {
    method: 'DELETE',
  })

// POST /api/v1/serverless/projects/workplaceai/{id}/_reset-credentials
// ts-unused-exports:disable-next-line
export const resetWorkplaceAIProjectCredentials = async (args: {
  pathParameters: operations['resetWorkplaceAIProjectCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters('/api/v1/serverless/projects/workplaceai/{id}/_reset-credentials', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/workplaceai/{id}/_reset-internal-credentials
// ts-unused-exports:disable-next-line
export const resetWorkplaceAIProjectInternalCredentials = async (args: {
  pathParameters: operations['resetWorkplaceAIProjectInternalCredentials']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectCredentials']>(
    applyParameters(
      '/api/v1/serverless/projects/workplaceai/{id}/_reset-internal-credentials',
      args,
    ),
    {
      method: 'POST',
    },
  )

// POST /api/v1/serverless/projects/workplaceai/{id}/_resume
// ts-unused-exports:disable-next-line
export const resumeWorkplaceAIProject = async (args: {
  pathParameters: operations['resumeWorkplaceAIProject']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/serverless/projects/workplaceai/{id}/_resume', args), {
    method: 'POST',
  })

// GET /api/v1/serverless/projects/workplaceai/{id}/link-candidates
// ts-unused-exports:disable-next-line
export const getWorkplaceAIProjectLinkCandidates = async (args: {
  pathParameters: operations['getWorkplaceAIProjectLinkCandidates']['parameters']['path']
  queryParameters?: operations['getWorkplaceAIProjectLinkCandidates']['parameters']['query']
}) =>
  fetchAsJson<components['schemas']['LinkedCandidatesList']>(
    applyParameters('/api/v1/serverless/projects/workplaceai/{id}/link-candidates', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/workplaceai/{id}/roles
// ts-unused-exports:disable-next-line
export const getWorkplaceAIProjectRoles = async (args: {
  pathParameters: operations['getWorkplaceAIProjectRoles']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectRolesByProjectID']>(
    applyParameters('/api/v1/serverless/projects/workplaceai/{id}/roles', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/serverless/projects/workplaceai/{id}/status
// ts-unused-exports:disable-next-line
export const getWorkplaceAIProjectStatus = async (args: {
  pathParameters: operations['getWorkplaceAIProjectStatus']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ProjectStatus']>(
    applyParameters('/api/v1/serverless/projects/workplaceai/{id}/status', args),
    {
      method: 'GET',
    },
  )
